import React from "react";
import CustomCarousel from "./custom-carousel/CustomCarousel";

/**
  * @param {import("swiper/react").SwiperProps} props

 */
export default function CarouselOrTag({ tag, isCarousel, children, ...props }) {
  if (isCarousel) {
    return (
      <CustomCarousel {...props}>
        {React.Children.toArray(children).filter((child) => child && child.type !== undefined)}
      </CustomCarousel>
    );
  }

  const Tag = tag || "div";

  return <Tag {...props}>{children}</Tag>;
}
